import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore/lite";
import { getAuth ,GoogleAuthProvider} from "firebase/auth";


const firebaseConfig = {
    apiKey: "AIzaSyBroUJtcaw0j5FOkqnMQtcxcrR0FA_Mbyw",
    authDomain: "react-blog-2c009.firebaseapp.com",
    projectId: "react-blog-2c009",
    storageBucket: "react-blog-2c009.appspot.com",
    messagingSenderId: "667084351650",
    appId: "1:667084351650:web:011dd0e62b34ad12e90ffb",
  };
  
  const app = initializeApp(firebaseConfig);
  const db = getFirestore(app);
  const auth=getAuth(app);
  const provider=new GoogleAuthProvider();
  
  export default db;
  export {auth,provider};